import { useMode } from "../mode/ModeContext";

const OPTIONS = [
  { value: "live", label: "Live mode", text: "Live" },
  { value: "test", label: "Test mode", text: "Test" },
] as const;

/** Segmented Live / Test sandbox switcher (Stripe-style), in the top bar. Switching reloads the
 *  app under the new mode so every view refetches the right dataset. */
export function ModeToggle() {
  const { mode, busy, switchMode } = useMode();
  return (
    <div role="group" aria-label="Data mode" className="inline-flex items-center gap-0.5 rounded-lg border border-line bg-surface-2 p-0.5">
      {OPTIONS.map(({ value, label, text }) => (
        <button
          key={value}
          type="button"
          aria-label={label}
          title={label}
          aria-pressed={mode === value}
          disabled={busy}
          onClick={() => void switchMode(value)}
          className={`rounded-md px-2 py-1 text-[11px] font-bold uppercase tracking-wide transition-colors ${
            mode === value
              ? value === "test"
                ? "bg-[#c9a227] text-black"
                : "bg-accent text-accent-ink"
              : "text-muted hover:text-ink"
          }`}
        >
          {text}
        </button>
      ))}
    </div>
  );
}
